import IOrdemCarregamentoRequest from '../entities/OrdemCarregamentoRequest'
import { IOrdemCarregamentoRepository } from '../repositories/IOrdemCarregamentoRepository'

export interface IFindByCodigoOcOuLoteSolicitadoId {
  execute(params: IOrdemCarregamentoRequest): Promise<string>
}

export default class IFindByCodigoOcOuLoteSolicitadoIdImpl
  implements IFindByCodigoOcOuLoteSolicitadoId
{
  constructor(
    private readonly ordemCarregamentoRepository: IOrdemCarregamentoRepository,
  ) {}

  public async execute(params: IOrdemCarregamentoRequest): Promise<string> {
    const response =
      await this.ordemCarregamentoRepository.findByCodigoOcOuLoteSolicitadoId(
        params,
      )
    return response
  }
}
